import React from 'react';
import { Icon } from './Icon.js';
export const IconEnvelope = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m3,7l6.504,3.716c.307.176.685.176.992,0l6.504-3.716", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("rect", { x: "3", y: "4", width: "14", height: "12", rx: "3", ry: "3", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconEnvelope.js.map